import { createBrowserHistory } from 'history';
import { includes } from 'ramda';
import { currentLanguage } from 'utils/currentLanguage';

export const isCountryPage = includes('country_page', window.location.href);
export const isTechAssistPage = includes('techassist', window.location.href);
export const isBlock = !isCountryPage && !isTechAssistPage;

const browserHistory = createBrowserHistory({
  basename: isTechAssistPage ? `/${currentLanguage}/techassist` : `/${currentLanguage}`,
});

export default browserHistory;



// WEBPACK FOOTER //
// ./src/utils/browserHistory.js